<p>
    Fallback rendering of type: <strong>{{ contentItem.metadata.type }}</strong>, id: <strong>{{
        contentItem.metadata.id }}</strong>, name: <strong>{{ contentItem.metadata.name }}</strong>
</p>
